/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Program_Volume_LabelInputs */



/**
* | output |
* | --- |
* | "Program volume" |
*
* @param {Player_Program_Volume_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_program_volume_label = /** @type {((inputs?: Player_Program_Volume_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Program_Volume_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Volume du programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programmlautstärke")
	if (locale === "it") return /** @type {LocalizedString} */ ("Volume del programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Громкость программы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volumen del programa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目音量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("番組音量")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोग्राम वॉल्यूम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volume do programa")
	return /** @type {LocalizedString} */ ("Program volume")
});